module.exports = __webpack_public_path__ + "6c847da3da00a083d408c2b25760e107.svg";